export default __webpack_public_path__ + "static/media/film.776493ac.PNG";